// extracted by mini-css-extract-plugin
module.exports = {"deltaproWrapper":"deltapro_deltaproWrapper___D1cm"};